module.exports = __webpack_public_path__ + "img/62.6edd399c.jpg";